import EntityTypes from 'parts/types/EntityTypes'

/** Возвращает дополнительные цены тарифа */
export function findAdditionalPrices(tariff: EntityTypes.Tariff) {
	return tariff.prices.filter((price) => !price.isMain)
}
